'use strict';

angular.module('internal.admin')
    .controller('InternalAdminEnterpriseSettings', ['$scope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
    }])
;